// Colour palette used in the product
export const PRIMARY = '#FE551B';

export const GREY_BLUE_LIGHT = '#abb7ca';
export const YELLOW_XXLIGHT = '#fffbed';
export const YELLOW = '#FFD139';

export const BACKDROP_BG = 'rgba(27, 30, 33, 0.77)';
export const BACKDROP_BG_LIGHT = 'rgba(0, 0, 0, 0.05)'; // Used during animation of backdrop
export const BACKDROP_BG_TRANSPARENT = 'rgba(0, 0, 0, 0.0)';

export const orange = {
    xxxlight: '#FFF8F2',
    xxlight: '#FEF2E3',
    xlight: '#FECDB8',
    light: '#FE7B49',
    base: '#FE551B',
    dark: '#CC410B',
    xdark: '#993108',
    xxdark: '#391400',
};

// PRIMARY
export const primary = {
    xxxlight: orange.xxxlight,
    xxlight: orange.xxlight,
    xlight: orange.xlight,
    light: orange.light,
    base: orange.base,
    dark: orange.dark,
    xdark: orange.xdark,
    xxdark: orange.xxdark,
};

// violet
export const violet = {
    xlight: '#dad4ff',
    light: '#b2a5ff',
    base: '#735cff',
    dark: '#5f45ff',
    xdark: '#442fc8',
};

// scarlet
export const scarlet = {
    xlight: '#ffcccb',
    light: '#ff918f',
    base: '#d33d3d',
    dark: '#cc3131',
    xdark: '#b41a1a',
};

// fuchsia
export const fuchsia = {
    xlight: '#fbe8f0',
    light: '#ef96b8',
    base: '#e44f89',
    dark: '#db3b79',
    xdark: '#c62c68',
};

// yellow
export const yellow = {
    xlight: '#ffeecf',
    light: '#ffd596',
    base: '#ffa72c',
    dark: '#f29d23',
    xdark: '#4d361a',
};

// blue
export const blue = {
    xlight: '#eaf3ff',
    light: '#cae2ff',
    base: '#348df8',
    dark: '#2d81e5',
    xdark: '#0e3460',
};

// green
export const green = {
    xxlight: '#dffff0',
    xlight: '#91eabf',
    light: '#4dde98',
    base: '#008847',
    dark: '#0c693d',
    xdark: '#0b4f2f',
};

// Light mode text
export const lightModeText = {
    xlight: '#8899a8',
    light: '#5c6975',
    base: '#3b454e',
    dark: '#050505',
};

// Dark mode text
export const darkModeText = {
    xdark: '#a2a9b9',
    dark: '#cccfd4',
    base: '#eaf2f7',
    light: '#ffffff',
};

export const darkModeGreyScale = {
    xxlight: '#374151',
    xlight: '#2d323a',
    light: '#2b2e39',
    base: '#22272e',
    dark: '#181c1f',
    xdark: '#14171c',
};

export const lightModeGreyScale = {
    xxlight: '#f5f7f9',
    xlight: '#eceff1',
    light: '#e3e8ed',
    base: '#d3dce4',
    dark: '#cccfd4',
    xdark: '#454545',
};

export const lightModeSidebar = {
    base: '#333d55',
    dark: '#283143',
};

// For dark theme
export const BACKDROP_DARK_BG = 'rgba(0, 0, 0, 0.6)';
export const BACKDROP_DARK_BG_LIGHT = 'rgba(0, 0, 0, 0.1)'; // Used during animation of backdrop
export const BACKDROP_DARK_BG_TRANSPARENT = 'rgba(0, 0, 0, 0)';

// GREY SCALE
export const WHITE = '#ffffff';
export const BLACK = '#242a31';
